import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-auth-callback',
  imports: [],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss'
})
export class AuthCallbackComponent implements OnInit {

  private router = inject(Router);
  private authService = inject(AuthService);

  ngOnInit(): void {
    console.log('Login callback');
    /*this.authService.handleRedirectCallback().subscribe({
      next: (result) => {
        console.log('Auth Callback', result.appState);
        // Optional: result.appState contains any state you passed to loginWithRedirect
        const targetRoute = result?.appState?.target ?? '/';
        this.router.navigate([targetRoute]);
      },
      error: (err) => {
        console.error('Error handling redirect callback', err);
        this.router.navigate(['/error']); // or show a local error message
      },
    });*/
  }

}
